/*
 *
 * EasySplitDetails actions
 *
 */
import { VENDOR_DATA_BY_ID } from '../Vendors/constants';
import {
  ADJUST_BALANCE,
  DEFAULT_ACTION,
  DISABLE_LOADER,
  DOWNLOAD_DOC,
  ENABLE_LOADER,
  GET_DOCS_BY_USER,
  GET_KYC_DOCS,
  GET_SETTLEMENT_CONFIG,
  GET_VENDOR_KYC_DETAILS,
  GET_VENDOR_OD_BALANCE,
  INITIATE_VENDOR_OD,
  RESET_REDUCER_STATES,
  SAVE_KYC_DOCS,
  SAVE_KYC_RESPONSE,
  SAVE_SETTLEMENT_CONFIG,
  SAVE_VENDOR_BY_ID,
  SAVE_VENDOR_DETAILS,
  SAVE_VENDOR_DOCS,
  SAVE_VENDOR_KYC_DETAILS,
  UPDATE_VENDOR,
  UPLOAD_KYC_DATA,
  UPLOAD_VENDOR_DOCS,
  VERIFY_CIN,
  VERIFY_GST,
  VERIFY_PAN,
} from './constants';
export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}
export function getVendorDataByIdAction(data) {
  return {
    type: VENDOR_DATA_BY_ID,
    data,
  };
}
export function saveVendorDetailsAction(data) {
  return {
    type: SAVE_VENDOR_DETAILS,
    data,
  };
}
export function getVendorKycDetailsAction(data) {
  return {
    type: GET_VENDOR_KYC_DETAILS,
    data,
  };
}
export function saveVendorKycDetailsAction(data) {
  return {
    type: SAVE_VENDOR_KYC_DETAILS,
    data,
  };
}
export function getKycDocsAction(data) {
  return {
    type: GET_KYC_DOCS,
    data,
  };
}
export function saveKycDocsAction(data) {
  return {
    type: SAVE_KYC_DOCS,
    data,
  };
}
export function adjustBalanceAction(data) {
  return {
    type: ADJUST_BALANCE,
    data,
  };
}
export function downloadDocAction(data) {
  return {
    type: DOWNLOAD_DOC,
    data,
  };
}
export function saveVendorByIdAction(data) {
  return {
    type: SAVE_VENDOR_BY_ID,
    data,
  };
}
export function saveKycResponseAction(data) {
  return {
    type: SAVE_KYC_RESPONSE,
    data,
  };
}
export function updateVendorAction(data) {
  return {
    type: UPDATE_VENDOR,
    data,
  };
}
export function uploadKycDataAction(data) {
  return {
    type: UPLOAD_KYC_DATA,
    data,
  };
}
export function getVendorOdBalanceAction(data) {
  return {
    type: GET_VENDOR_OD_BALANCE,
    data,
  };
}
export function initiateVendorOdAction(data) {
  return {
    type: INITIATE_VENDOR_OD,
    data,
  };
}
export function resetReducerStatesAction(data) {
  return {
    type: RESET_REDUCER_STATES,
    data,
  };
}
export function getSettlementConfigAction(data) {
  return {
    type: GET_SETTLEMENT_CONFIG,
    data,
  };
}
export function saveSettlementConfigAction(data) {
  return {
    type: SAVE_SETTLEMENT_CONFIG,
    data,
  };
}
export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}
export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function getDocsByUserAction(data) {
  return {
    type: GET_DOCS_BY_USER,
    data,
  };
}

export function saveVendorDocsAction(data) {
  return {
    type: SAVE_VENDOR_DOCS,
    data,
  };
}

export function uploadVendorDocsAction(data) {
  return {
    type: UPLOAD_VENDOR_DOCS,
    data,
  };
}

export function verifyPanAction(data) {
  return {
    type: VERIFY_PAN,
    data,
  };
}

export function verifyCinAction(data) {
  return {
    type: VERIFY_CIN,
    data,
  };
}

export function verifyGstAction(data) {
  return {
    type: VERIFY_GST,
    data,
  };
}
